import { useLocation, useNavigate } from 'react-router-dom';

export function usePatchedNavigate() {
  const navigate = useNavigate();
  const location = useLocation();

  return (to, options) => {
    if (typeof to === 'string') {
      const currentProjectId = new URLSearchParams(location.search).get('projectId');
      const targetUrl = new URL(to, window.location.origin);
      const targetParams = new URLSearchParams(targetUrl.search);

      if (currentProjectId && !targetParams.get('projectId')) {
        targetParams.set('projectId', currentProjectId);
        targetUrl.search = targetParams.toString();
        to = targetUrl.pathname + '?' + targetParams.toString();
      }
    }
    navigate(to, options);
  };
}
